/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPopularFeedGenerators.defs.js'
export * as $defs from './getPopularFeedGenerators.defs.js'
